code

<template>
  <!--        <img alt="Vue logo" src="./assets/logo.png">-->
  <!--        <HelloWorld msg="Welcome to Your Vue.js App Abdullah"/>-->
  <div class="container">
    <div class="row fh-row justify-content-center">
      <div class="col-md-6 pl-0 pr-0 align-self-center">

        <mdb-card class="z-depth-1 card-height">

          <mdb-card-header color="white">
            <div class="container-fluid">
              <div class="row">
                <div :class="$store.state.reseller_logo? 'col-6': 'col-3'" class="col-md-4 align-self-center text-left">
                  <img v-if="$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                </div>
                <div :class="$store.state.reseller_logo? 'col-2': 'col-6'" class="col-md-4">
                  <img v-if="!$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                </div>
                <div :class="$store.state.reseller_logo? 'col-4': 'col-3'" class="col-md-4 col-4 align-self-center text-right">
                  <img v-if="$store.state.reseller_logo" :src="$store.state.reseller_logo" alt="Card image cap" class="img-fluid img-banner"/>
                </div>
              </div>
            </div>
          </mdb-card-header>
          <mdb-card-body class="text-center">
              <div class="container-fluid">
                <div class="hh-row">
                    <div class="loader" v-if="waiting">Loading...</div>
                    <span v-if="waiting===false">
                        <div class="swal2-icon swal2-success swal2-animate-success-icon"
                             style="display: flex;"
                             v-if="session.status === 'Verified' || session.status === 'manually authenticated'">
                            <div class="swal2-success-circular-line-left"></div>
                            <span class="swal2-success-line-tip"></span>
                            <span class="swal2-success-line-long"></span>
                            <div class="swal2-success-ring"></div>
                            <div class="swal2-success-fix"></div>
                            <div class="swal2-success-circular-line-right"></div>
                        </div>
                          <div v-if="session.status === 'Not Verified'"
                               class="swal2-icon swal2-error swal2-animate-error-icon"
                               style="display: flex;"><span class="swal2-x-mark"><span
                              class="swal2-x-mark-line-left"></span><span
                              class="swal2-x-mark-line-right"></span></span>
                          </div>
                          <div v-if="session.status === 'Pending'"
                               class="swal2-icon swal2-warning swal2-animate-error-icon swal2-icon-show" style="display: flex;">
                               <div class="swal2-icon-content">!</div>
                          </div>
                          <div v-if="['Verified', 'Not Verified'].includes(session.status)">
                            <p :class="session.status === 'Verified'? 'text-success': 'text-danger'">{{ session.status }}</p>
                          </div>
                          <div v-else-if="session.status === 'Pending'">
                            <p>Manual Verification in Progress. Please Wait...</p>
                          </div>
                      </span>

                    <mdb-btn v-if="waiting===false" block color="white" class size="md mb-2" @click="displayOptions">
                      <strong>Verification Report</strong>
                      <i style="font-size: 15px" class="fa float-right"
                         :class="displayReport? 'fa-chevron-up': 'fa-chevron-down'" aria-hidden="true"></i>
                    </mdb-btn>

                    <template v-if="waiting===false && displayReport">
                      <div>
                        <mdb-tbl borderless class="report-table">
                          <mdb-tbl-body>
                            <tr key="id">
                              <td align="left">Session ID</td>
                              <td align="left"><strong>{{ session_id }}</strong></td>
                            </tr>
                            <tr
                                v-for="[key, value] in Object.entries(sessionReport)"
                                :key="key"
                            >
                              <td align="left">{{ splitAndCapitalize(key) }}</td>
                              <td align="left">
                                <i class="fa" :class="statusIcons[value.status]" />
                              </td>
                            </tr>
                          </mdb-tbl-body>
                        </mdb-tbl>
                      </div>
                    </template>

                    <mdb-btn v-if="waiting===false" block color="white" class size="md mb-2" @click="displayOptions">
                      <strong>Personal Details</strong>
                      <i style="font-size: 15px" class="fa float-right"
                         :class="displayDetails? 'fa-chevron-up': 'fa-chevron-down'" aria-hidden="true"></i>
                    </mdb-btn>

                    <template v-if="waiting===false && displayDetails">
                      <div>
                        <mdb-tbl borderless class="report-table">
                          <mdb-tbl-body>
                            <tr v-for="(value, key) in showable_extracted_data" :key="key">
                              <td align="left">{{key}}</td>
                              <td align="left"><strong >{{ value===''? "-":value}}</strong></td>
                            </tr>
                          </mdb-tbl-body>
                        </mdb-tbl>
                      </div>
                    </template>
<!--                      <mdb-btn block color="white" class size="md" @click="display = !display">-->
<!--                        {{ $t("optionalFields") }}-->
<!--                        <i style="font-size: 15px" class="fa float-right"-->
<!--                           :class="display? 'fa-chevron-up': 'fa-chevron-down'" aria-hidden="true"></i>-->
<!--                      </mdb-btn>-->

<!--                      <div v-if="display" class="form-group">-->
<!--                        <mdb-input :label="$t('emailAddress')" type="email" v-model="email_address" />-->
<!--                        <mdb-input :label="$t('mailingAddress')" v-model="mailing_address" />-->
<!--                      </div>-->

                </div>
              </div>
          </mdb-card-body>
          <mdb-card-footer>
            <div class="col-12 align-self-center">
              <div class="row justify-content-center">
                <div class="col-md-12 mb-1 mt-1">
                  <mdb-btn style="font-size: 15px" block color="primary"
                           :disabled="redirect_url===null || session.status === 'Pending'"
                           class="next-btn" size="md" @click="redirect">
                    {{ $t("next") }}
                    <i style="font-size: 22px" class="fa-arrow-right fas fa-2x float-right"></i>
                  </mdb-btn>
                </div>
              </div>
            </div>
          </mdb-card-footer>
        </mdb-card>
      </div>
    </div>
    <div id="overlay" v-if="spinner">
      <div style="position: fixed;top: 50%;left: 45%; width: 10%;" class="text-center text-white">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>

        </div>
        <p>{{ $t("waitMsg") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {i18n} from "../../translations";

export default {
  name: "About",
  components: {
    // HelloWorld,
  },
  data() {
    return {
      spinner: false,
      selected_agent: null,
      session: {},
      isLastStep: false,
      sessionReport: {},
      email_address: null,
      mailing_address: null,
      display: false,
      displayDetails: false,
      displayReport: true,
      id: "",
      address: "",
      trusted_partner_name: "",
      email: "",
      name: "",
      country: "",
      father_name: "",
      gender: "",
      date_of_birth: "",
      date_of_issue: "",
      date_of_expiry: "",
      blur: "",
      session_id: "",
      waiting: true,
      agent_name: null,
      redirect_url: null,
      showable_extracted_data:{},
      statusIcons: {
        true: "fa-check-circle text-success",
        "manually authenticated": "fa-check-circle text-success",
        "manually authenticated by VO": "fa-check-circle text-success",
        false: "fa-times-circle text-danger",
        error: "fa-times-circle text-danger",
        null: "fa-question-circle text-black",
        working: "fa-exclamation-circle text-warning",
        pending: "fa-exclamation-circle text-warning",
      },
    }
  },
  async mounted() {
    this.isLastStep = this.$route.path === this.$store.state.configPath[this.$store.state.configPath.length - 1]
    i18n.locale = this.$store.state.language
    this.$store.commit('assignStep', this.$route.path)
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (this.$store.state.session_id != null) {

      let extracted_data = await this.$http.get('/sessions/' + this.$store.state.session_id + '/');
      const baseUrl = process.env.VUE_APP_BASE_URL.replace('http', 'ws')
      const socket = new WebSocket(`${baseUrl}/ws/checks/session_${this.$store.state.session_id}/?key=${params.key}`)

      socket.onmessage = (msg => {
        const session = JSON.parse(msg.data).message
        this.session = session
        this.session_id = session.id
        if (this.session && this.session.report && this.session.report.document_capture &&
            this.session.report.document_capture.report.extracted_data) {
          this.$store.commit("setExtractTextState", {
            state: true,
            data: this.session.report.document_capture.report.extracted_data
          });
          this.showable_extracted_data = this.session.report.document_capture.report.extracted_data
          this.showable_extracted_data = Object.fromEntries(Object.entries(this.showable_extracted_data).filter(([k,v]) =>
              !["names", "cities"].includes(k)))
        }
        this.sessionReport = Object.fromEntries(Object.entries(this.session.report).filter(([k,v]) =>
            v !== null && typeof v === "object" && v.show_in_report !== false))
        this.setReportVariables()
      })
      socket.onerror = function(err){
      }

      this.session = extracted_data.data;
      this.session_id = this.session.id
      this.redirect_url = this.session.client_redirect_url
      if (extracted_data.data.agent !== null) {
        this.agent_name = extracted_data.data.agent.name
      }
      // Filter out features that has show in report false
      if (this.session && this.session.report && this.session.report.document_capture &&
          this.session.report.document_capture.report.extracted_data) {
        this.$store.commit("setExtractTextState", {
          state: true,
          data: this.session.report.document_capture.report.extracted_data
        });

        this.showable_extracted_data = this.session.report.document_capture.report.extracted_data
        this.showable_extracted_data = Object.fromEntries(Object.entries(this.showable_extracted_data).filter(([k,v]) =>
            !["names", "cities"].includes(k)))
      }
      this.sessionReport = Object.fromEntries(Object.entries(this.session.report).filter(([k,v]) =>
          v !== null && typeof v === "object" && v.show_in_report !== false))
      this.setReportVariables()

      this.waiting = false
    }

    if (this.isLastStep) {
      this.$localForageService.clear();
      this.$store.commit("setExtractTextState", {
        state: false,
        data: false
      });
      this.$store.commit("setTrustedPartnerState", {
        name: "",
        number: ""
      });
      this.$store.commit("setSessionID", {
        session_id: null,
        agent_name: null
      })
      this.$store.commit('setManualVerification', {
        manual_verification: false
      })
      this.$store.commit('setSelectedAgent', {
        selected_agent: null
      })
    }
  },
  methods:{
    displayOptions() {
      this.displayReport = !this.displayReport
      this.displayDetails = !this.displayDetails
    },
    splitAndCapitalize(str) {
      let i, frags = str.split('_');
      for (i=0; i<frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(' ').replace('Id', 'ID');
    },
    navigate() {
      if (this.email_address || this.mailing_address) {
        this.spinner = true;
        let formData = new FormData();
        formData.append('session', this.$store.state.session_id);
        formData.append('email', this.email_address);
        formData.append('mailing_address', this.mailing_address);
        this.$http.post("/optional-fields", formData).then(r => {
          const urlSearchParams = new URLSearchParams(window.location.search);
          const params = Object.fromEntries(urlSearchParams.entries());
          this.$router.push({path:this.$store.state.configPath[this.$store.state.step],query:params})
          this.spinner = false
        }).catch(err => {
          this.handleError(err)
        })
      } else {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        this.$router.push({path:this.$store.state.configPath[this.$store.state.step],query:params})
      }
    },
    redirect() {
      if (this.isLastStep) {
        let query = new URLSearchParams();
        // query.append("session", JSON.stringify(this.session));

        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());

        query.append("session", JSON.stringify(this.session));
        query.append("meta", JSON.stringify(params.meta));

        window.location.href = this.redirect_url+(this.redirect_url.includes('client=')? "&": "?")+query
      } else {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        this.$router.push({path:this.$store.state.configPath[this.$store.state.step],query:params})
      }
    },
    setReportVariables() {
      this.selected_agent = this.$store.state.selected_agent
      // this.id = this.$store.state.extractedText['Identity Number'];
      // this.name = this.$store.state.extractedText['Name'];
      // this.father_name = this.$store.state.extractedText['Father Name'];
      // this.gender = this.$store.state.extractedText['Gender'];
      // this.date_of_birth = this.$store.state.extractedText['Date of Birth'];
      // this.date_of_issue = this.$store.state.extractedText['Date of Issue'];
      // this.date_of_expiry = this.$store.state.extractedText['Date of Expiry'];
      // this.country = this.$store.state.extractedText['Country of Stay'];
      // this.blur = this.$store.state.extractedText.blur;
      // this.session_id = this.$store.state.session_id;

      //
      // this.id = this.id === '' || this.id === null ? {value: "Not Detected", error: true} : {
      //   value: this.id,
      //   error: false
      // };
      // this.name = this.name === '' || this.name === null ? {value: "Not Detected", error: true} : {
      //   value: this.name,
      //   error: false
      // };
      // this.father_name = this.father_name === '' || this.father_name === null ? {
      //   value: "Not Detected",
      //   error: true
      // } : {value: this.father_name, error: false};
      // this.gender = this.gender === '' || this.gender === null ? {
      //   value: "Not Detected",
      //   error: true
      // } : {value: this.gender, error: false};
      // this.date_of_birth = this.date_of_birth === '' || this.date_of_birth === null ? {
      //   value: "Not Detected",
      //   error: true
      // } : {value: this.date_of_birth, error: false};
      //
      // this.date_of_issue = this.date_of_issue === '' || this.date_of_issue === null ? {
      //   value: "Not Detected",
      //   error: true
      // } : {value: this.date_of_issue, error: false};
      // this.date_of_expiry = this.date_of_expiry === '' || this.date_of_expiry === null ? {
      //   value: "Not Detected",
      //   error: true
      // } : {value: this.date_of_expiry, error: false};
      // this.country = this.country === '' || this.country === null ? {
      //   value: "Not Detected",
      //   error: true
      // } : {value: this.country, error: false};
    }
  }
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");

$image-path: "~@/../mdb/mdbvue/img";

.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}

.report-table td {
  padding-top: 0 !important;
  padding-bottom: 0.5rem !important;
}

.loader {
  color: #4285f4;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}

.loader:before,
.loader:after {
  position: absolute;
  content: '';
}

.loader:before {
  width: 5.2em;
  height: 10.2em;
  background: #fff;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.1em 5.1em;
  transform-origin: 5.1em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}

.loader:after {
  width: 5.2em;
  height: 10.2em;
  background: #fff;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 4.9em;
  -webkit-transform-origin: 0.1em 5.1em;
  transform-origin: 0.1em 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}

@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
